'use client';

import { SessionsLogo } from '@askable/ui/icons';
import { cn } from '@askable/ui/lib/utils';

import { HelpMenu } from '@/components/Layouts/AllLayout/components/HelpMenu';
import { SignInButton } from '@/components/Layouts/AllLayout/components/SignInButton';
import { UserMenu } from '@/components/Layouts/AllLayout/components/UserMenu';
import { useViewerContext } from '@/context/ViewerContext/ViewerContext';
import { useIsKinde } from '@/hooks/useIsKinde/useIsKinde';

const Header = ({ showLoginHint, className }: { showLoginHint?: boolean; className?: string }) => {
  const { status } = useViewerContext();
  const isKinde = useIsKinde();

  return (
    <header
      className={cn(
        'sticky top-0 z-10 flex items-center justify-between p-2 backdrop-blur-sm sm:px-4 sm:py-3',
        className,
      )}
    >
      <h2 className="pl-1">
        <SessionsLogo />
      </h2>

      <div className="flex items-center gap-2">
        {status === 'authenticated' ? <HelpMenu /> : ''}
        {status === 'authenticated' ? <UserMenu /> : ''}
        {status === 'unauthenticated' && isKinde ? <SignInButton showLoginHint={!!showLoginHint} /> : null}
      </div>
    </header>
  );
};

export default Header;
